import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {
    usuario: "", 
    email: "", 
    idEmitenteML: "", 
    idEmitenteMLUsuario: "", 
    emitenteML: "", 
    perfis: [], 
    permissoes: [],
    acessaSpirit: false, 
    avatar: {}, 
    logomarca: "", 
    repasseDireto: false, 
    avisaOnlineOffline: true, 
    medicoUsuario: {}, 
    creditosWhatsApp: 0, 
    creditosSMS: 0, 
    creditosTeleatendimento: 0, 
    creditosIA: 0, 
    powerBILink: "", 
    loadingUserInfo: true, 
    loadingPerfil: false
};

const getters = {
    usuario(state) {
        return state.usuario;
    },
    email(state) {
        return state.email;
    },
    idEmitenteML(state) {
        return state.idEmitenteML;
    },
    idEmitenteMLUsuario(state) {
        return state.idEmitenteMLUsuario;
    },
    emitenteML(state) {
        return state.emitenteML;
    },
    perfis(state) {
        return state.perfis;
    },
    permissoes(state) {
        return state.permissoes;
    },
    acessaSpirit(state) {
        return state.acessaSpirit;
    },
    avatar(state) {
        return state.avatar;
    },
    logomarca(state) {
        return state.logomarca;
    },
    repasseDireto(state) {
        return state.repasseDireto;
    },
    avisaOnlineOffline(state) {
        return state.avisaOnlineOffline;
    },
    medicoUsuario(state) {
        return state.medicoUsuario;
    }, 
    creditosWhatsApp(state) {
        return state.creditosWhatsApp;
    }, 
    creditosSMS(state) {
        return state.creditosSMS;
    }, 
    creditosTeleatendimento(state) {
        return state.creditosTeleatendimento;
    }, 
    creditosIA(state) {
        return state.creditosIA;
    }, 
    powerBILink(state) {
        return state.powerBILink;
    }, 
    loadingUserInfo(state) {
        return state.loadingUserInfo;
    }, 
    loadingPerfil(state) {
        return state.loadingPerfil;
    }
};

const mutations = {
    updateUserInfo(store, userInfo) {
        if(userInfo.idEmitenteML) {
            store.idEmitenteML = userInfo.idEmitenteML;
        }

        if(userInfo.idEmitenteMLUsuario) {
            store.idEmitenteMLUsuario = userInfo.idEmitenteMLUsuario;
        }

        if(userInfo.usuario) {
            store.usuario = userInfo.usuario;
        }

        if(userInfo.email) {
            store.email = userInfo.email;
        }

        if(userInfo.nome) {
            store.emitenteML = userInfo.nome;
        }

        if((userInfo.perfis) && (userInfo.perfis.length)) {
            store.perfis = userInfo.perfis;
        } else {
            store.perfis = [];
        }

        if((userInfo.acessaSpirit) && (userInfo.acessaSpirit == 1)) {
            store.acessaSpirit = true;
        }

        if(userInfo.logomarca) {
            store.logomarca = userInfo.logomarca;
        }

        if((userInfo.repasseDireto) && (userInfo.repasseDireto == 1)) {
            store.repasseDireto = true;
        }

        if(userInfo.creditosWhatsApp !== undefined) {
            store.creditosWhatsApp = userInfo.creditosWhatsApp;
        }

        if(userInfo.creditosSMS !== undefined) {
            store.creditosSMS = userInfo.creditosSMS;
        }

        if(userInfo.creditosTeleatendimento) {
            store.creditosTeleatendimento = userInfo.creditosTeleatendimento;
        }

        if(Object.prototype.hasOwnProperty.call(userInfo, 'creditosIA')) {
            store.creditosIA = userInfo.creditosIA;
        }

        if(userInfo.powerBILink) {
            store.powerBILink = userInfo.powerBILink;
        }
        
        store.loadingUserInfo = false;
    }, 
    updatePermissoes(store, permissoes) {
        store.permissoes = permissoes;
    }, 
    updateAvatar(store, avatar) {
        store.avatar = avatar;
    },
    updateAvisaOnlineOffline(store, avisaOnlineOffline) {
        store.avisaOnlineOffline = avisaOnlineOffline;
    }, 
    updateMedicoUsuario(store, medicoUsuario) {
        store.medicoUsuario = medicoUsuario;
    }, 
    updateLoadingUserInfo(store, loading) {
        store.loadingUserInfo = loading;
    }, 
    updateLoadingPerfil(store, loading) {
        store.loadingPerfil = loading;
    }
};

const actions = {
    atualizarAvisaOnlineOffline({ commit }, avisaOnlineOffline) {
        commit("updateAvisaOnlineOffline", avisaOnlineOffline);
    }, 
    atualizarLoadingPerfil({ commit }, loading) {
        commit("updateLoadingPerfil", loading);
    }, 
    async getValidateToken({ commit }) {
        if(JwtService.getToken()) {
            ApiService.setHeader();

            try {
                let { data } = await ApiService.post("auth/verify/", {SISTEMA: JwtService.getSistema()});
                commit("updateUserInfo", data);
                if((data.medicoUsuario) && (data.medicoUsuario.ID_MEDICO)) {
                    commit("updateMedicoUsuario", data.medicoUsuario);
                }
                if(data.token) {
                    JwtService.saveToken(data.token);
                }

                return data;
            } catch (error) {
                console.error(error);
                return {
                    resultado: false
                };
            }
        }
    },
    getUsuarios(context, dados) {
        if ((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/listarNuvem", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUsuariosTodos() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuarios/access/listarNuvemTodos").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUsuario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/obterNuvem", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUsuariosLocal() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuarios/access/listarLocal").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUsuariosPerfisLocal(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/listarUsuariosPerfisLocal", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postUsuario(context, usuario) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/salvar", usuario).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAvatar({ commit }, idEmitenteMLUsuario) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/obterAvatar", {id: idEmitenteMLUsuario}).then(({ data }) => {
                    commit('updateAvatar', data);
                    resolve(data);
                });
            }
        });
    },
    postAvatar({ commit }, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/salvarAvatar", dados).then(({ data }) => {
                    commit('updateAvatar', data);
                    resolve(data);
                });
            }
        });
    },
    salvarNovaSenha(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/salvarNovaSenha", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    validarSenha(context, senha) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/validarSenha", {SENHA: senha}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    logout() {
        JwtService.destroyToken();
        window.location.href = "https://auth.micrologos.com.br/#/login/" + JwtService.getSistema();
        // window.location.href = "https://auth.clinicspirit.com/#/login/" + JwtService.getSistema();
    },
    recuperarSenha(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("auth/recuperarSenha", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    gerarNovaSenha(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/gerarNovaSenha", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    aceitarCobrancaTeleatendimento() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuarios/access/aceitarCobrancaTeleatendimento").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    registrarMenuFavorito(context, acesso) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/registrarMenuFavorito", {ACESSO: acesso}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    listarMenusFavoritos() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("usuarios/access/listarMenusFavoritos").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvarFacebookInstagram(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("usuarios/access/salvarFacebookInstagram", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    updatePermissoes(context, permissoes) {
        context.commit('updatePermissoes', permissoes);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
